import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { MissionItem, MissionsService } from "../services/missions/missions.service";

interface AllMissionsState {
  openMissions: MissionItem[];
  completedMissions: MissionItem[];
  isLoading: boolean;
  lastUpdated: number | null;

  fetchAllMissions: (force?: boolean) => Promise<void>;
  reset: () => void;
}

let fetchPromise: Promise<void> | null = null;

export const useAllMissionsStore = create(
  persist<AllMissionsState>(
    (set, get) => ({
      openMissions: [],
      completedMissions: [],
      isLoading: false,
      lastUpdated: null,

      fetchAllMissions: async (force = false) => {
        // Freshness check: skip if updated within the last 5 seconds
        const { lastUpdated } = get();
        if (!force && lastUpdated && Date.now() - lastUpdated < 5000) {
          return;
        }

        // Lock parallel requests
        if (fetchPromise) return fetchPromise;

        fetchPromise = (async () => {
          set({ isLoading: true });
          try {
            const service = new MissionsService();
            const data = await service.getAllMissions();
            set({
              openMissions: data.open_missions,
              completedMissions: data.completed_missions,
              lastUpdated: Date.now(),
              isLoading: false
            });
          } catch (error) {
            console.error("Failed to fetch all missions:", error);
            set({ isLoading: false });
          } finally {
            fetchPromise = null;
          }
        })();

        return fetchPromise;
      },

      reset: () => set({
        openMissions: [],
        completedMissions: [],
        isLoading: false,
        lastUpdated: null
      }),
    }),
    {
      name: "shoonit_all_missions_storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
